import { DatabaseModel, DatabaseModelElement } from "./DatabaseModel";
import { Grid } from "@mui/material";
import { Visibility } from "@mui/icons-material";
import React from "react";
// @ts-ignore
import { Link } from "react-router";
import Debtor from "./Debtor";
import axios, { AxiosResponse } from "axios";

export enum Type {
  INVOICE = "INVOICE",
  COMMISSION = "COMMISSION",
}

export enum Status {
  CONCEPT = "CONCEPT",
  SENT = "SENT",
  PAID = "PAID",
  PARTIALLY_PAID = "PARTIALLY_PAID",
  CREDITED = "CREDITED",
  CANCELED = "CANCELED",
}

export default class Invoice extends DatabaseModel implements DatabaseModelElement {
  static modelName = "subsInvoice";
  constructor(
    public id: number = 0,

    public subs_debtor_id: number | null = null,
    public description: string | null = null,
    public gripp_reference: string | null = null,
    public type: string | null = null,
    public status: string | null = null,
    public invoice_date: Date | null = null,
    public invoice_date_unix: number | null = null,
    public expire_date: Date | null = null,
    public expire_date_unix: number | null = null,
    public block_subscription_date: Date | null = null,
    public block_subscription_date_unix: number | null = null,
    public amount: number | null = null,
    public amount_paid: number | null = null,
    public amount_discount: number | null = null,
    public amount_credited: number | null = null,
    public amount_outstanding: number | null = null,
    public sent_email_count: number | null = null,
    public created_at: Date = new Date(),
    public updated_at: Date = new Date(),
    public deleted_at: Date | null = null,
    public subsDebtor: Debtor | null = null
  ) {
    super();
  }

  static CreateModel(model: any): Invoice {
    return new Invoice(
      model.id,
      model.subs_debtor_id,
      model.description,
      model.gripp_reference,
      model.type,
      model.status,
      new Date(model.invoice_date),
      model.invoice_date_unix,
      new Date(model.expire_date),
      model.expire_date_unix,
      new Date(model.block_subscription_date),
      model.block_subscription_date_unix,
      model.amount,
      model.amount_paid,
      model.amount_discount,
      model.amount_credited,
      model.amount_outstanding,
      model.sent_email_count,
      new Date(model.created_at),
      new Date(model.updated_at),
      model.deleted_at ? new Date(model.deleted_at) : null,
      model.subs_debtor ? Debtor.CreateModel(model.subs_debtor) : null
    );
  }

  static uploadToGripp(id: number) {
    return new Promise((resolve: (value: any) => void, reject) => {
      axios
        .post("core/" + Invoice.modelName + "/uploadToGripp", { id })
        .then((response: AxiosResponse) => {
          resolve({ response });
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  static sendToDebtor(id: number) {
    return new Promise((resolve: (value: any) => void, reject) => {
      axios
        .post("core/" + Invoice.modelName + "/sendToDebtor", { id })
        .then((response: AxiosResponse) => {
          resolve({ response });
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  static mergeConcepts(ids: number[]) {
    return new Promise((resolve: (value: any) => void, reject) => {
      axios
        .post("core/" + Invoice.modelName + "/mergeConcepts", { ids })
        .then((response: AxiosResponse) => {
          resolve({ response });
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  static generateInvoices() {
    return new Promise((resolve: (value: any) => void, reject) => {
      axios
        .post("core/" + Invoice.modelName + "/generateInvoices", {})
        .then((response: AxiosResponse) => {
          resolve({ response });
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  tableRow() {
    return (
      <>
        <Grid item xs={6}>
          {this.description}
        </Grid>
        <Grid item xs={6}>
          <Link to={{ pathname: Invoice.editPath(this.id) }}>
            <Visibility />
          </Link>
        </Grid>
      </>
    );
  }
}
